var get_login;

$(document).ready(function() {
  $('#contact-link').fancybox({
    href: '#contact',
    wrapCSS: 'popup-box',
    topRatio: 0.2
  });
  $('.popupbox').each(function() {
    return $(this).fancybox({
      wrapCSS: 'popup-box',
      href: $(this).attr('href') + '.popup',
      topRatio: 0.2
    });
  });
  $('.contact-form').submit(function() {
    var data;
    $('#contact-submit').attr('disabled', 'disabled');
    data = $(this).serialize();
    $.post('/contact.json', data, function(response) {
      $('#contact-submit').toggle();
      return $('.thanks').toggle();
    });
    return false;
  });
  $.expr[':'].external = function(obj) {
    return !obj.href.match(/^mailto\:/) && (obj.hostname !== location.hostname) && !obj.href.match(/^javascript\:/) && !obj.href.match(/^$/);
  };
  return $('a:external').attr('target', '_blank');
});

get_login = function() {
  return $.fancybox.open([
    {
      href: '/user.popup',
      type: 'ajax',
      wrapCSS: 'popup-box',
      topRatio: 0.2
    }
  ], {
    padding: 2
  });
};

if (window.location.hash === '#_=_') {
  window.location.hash = '';
}

$(window).scroll(function() {
  if ($(this).scrollTop() > 1) {
    return $('#header').addClass('sticky-header');
  } else {
    return $('#header').removeClass('sticky-header');
  }
});

//# sourceMappingURL=init.js.map
